import $ from 'jquery';

export default class CartTerms {
    constructor(theme, element) {
        this.theme = theme;
        this.element = element;

        this.agree = /** @type {HTMLInputElement} */ (this.element.querySelector('#agree'));
    }

    checkTerms = (event) => {
        const $form = $(event.currentTarget).closest('form');
        if (this.agree &&! this.agree.checked) {
            alert(this.agree.dataset.termsAgree);
            $form.find('.cart-button-checkout-text').removeClass('hide');
            $form.find('.cart-button-checkout-spinner').addClass('hide');
            event.preventDefault();
            return false;
        }
    }
}
